import { tourStepKey, tourKeyParam } from 'core/tour-v2/constants';

import { PageTourArgs, NormalizedTourStep } from '../types';

type GetTourStepUrlParams = {
  baseUrl: string;
  tourKey: string;
  tourStepId: string;
};

export const normalizeSteps = (
  pageTourArgs: PageTourArgs[],
  tourKey: string
): NormalizedTourStep[] => {
  const normalizedSteps: NormalizedTourStep[] = [];

  pageTourArgs.forEach((page) => {
    if (page.steps.length > 0) {
      // Flatten the steps
      page.steps.forEach((step) => {
        normalizedSteps.push({
          tourKey,
          id: step.id,
          page: page.id,
          url: page.url,
          tooltip: step.tooltip,
          globalStyles: step.globalStyles,
          overlay: step.overlay,
          state: (api) => {
            const stateOrResolver = step.state ?? page.state;
            return typeof stateOrResolver === 'function'
              ? stateOrResolver({ api })
              : stateOrResolver;
          },
          goNext: step.goNext,
          onBefore: step.onBefore,
          onAfter: step.onAfter,
        });
      });
    }
  });

  return normalizedSteps;
};

export const getTourStepUrl = ({
  baseUrl,
  tourKey,
  tourStepId,
}: GetTourStepUrlParams) => {
  const url = new URL(baseUrl, window.location.origin);
  url.searchParams.set(tourKeyParam, tourKey);
  url.searchParams.set(tourStepKey, tourStepId);
  return url.pathname + url.search;
};
